<template>
    <form @submit.prevent="submitForm" >
        <div class="row">
            <div class="col-md-6">
                <field-mobile required v-model="form.mobile" label="موبایل" placeholder="" :readonly="this.edit != null"/>
                <field-text required v-model="form.name" label="نام" placeholder=""/>
                <field-text required v-model="form.email" label="ایمیل" placeholder=""/>
            </div>
            <div class="col-md-6">
                <field-password :required="!this.edit" v-model="form.password" label="پسورد" placeholder=""/>
                <field-select required v-model="form.is_admin"  :options="is_admin_options" label="دسترسی به بخش مدیریت" placeholder=""/>
            </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
    import ButtonSubmit from "../ButtonSubmit";
    import Alert from "../Alert";
    import FieldPassword from "../fields/FieldPassword";
    import FieldMobile from "../fields/FieldMobile";
    import FieldEmail from "../fields/FieldEmail";

    import mixinForm from "../../mixins/mixinForm";
    import FieldSelect from "../fields/FieldSelect";
    import FieldText from "../fields/FieldText";

    export default {
        mixins: [mixinForm],
        components: {
            FieldSelect,
            FieldText,
            FieldEmail,
            FieldMobile,
            FieldPassword,
            Alert,
            ButtonSubmit,
        },
        name: "FormUser",
        data() {
            return {
                is_admin_options:[
                    {text:'بلی',value:'1'},
                    {text:'خیر',value:'0'},
                ],
                action: "/fa/v1/users",
            }
        },
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/FormUser.vue